import * as React from 'react';
import { StepsPanelProps } from './StepsPanel.types';

import './styles/StepsPanel.css';

export const StepsPanel = ({
    step,
    title,
    subTitle,
    className,
    children,
}: StepsPanelProps): JSX.Element => {
    return (
        <div
            className={
                `steps-panel
                ${step % 2 === 0 ? 'steps-panel--alt' : ''}
                steps-panel-${step}
                ${className}
            `}
            tabIndex={-1}
        >
            {title !== '' && (
                <div 
                    className="steps-panel__header"
                >
                    <h3>
                        <span className="steps-panel__header__step-index">{step}</span> {title}
                    </h3>
                    { subTitle && (
                        <div>
                            {subTitle}
                        </div>
                    )}
                </div>
            )}
            <div className="steps-panel__content">
                {children}
            </div>
        </div>
    );   
};